import { useEffect } from 'react';

export const useSetMobileViewportMeta = () => {
    useEffect(() => {
        const viewport = document.querySelector('meta[name="viewport"]');

        if (!viewport) {
            const meta = document.createElement('meta');
            meta.name = 'viewport';
            document.head.appendChild(meta);
        }

        viewport?.setAttribute(
            'content',
            'width=device-width, initial-scale=1.0, maximum-scale=1.0',
        );

        return () => {
            const dynamicViewport = document.querySelector(
                'meta[name="viewport"][data-dynamic="true"]',
            );
            if (dynamicViewport) {
                dynamicViewport.remove();
            }
        };
    }, []);
};
